const MailManagement = () => {
  return (
    <div>
      <div className="bg-[#efefef] flex justify-center items-center h-[150px]">
        <h1 className="text-[40px] font-bold">Mail Management Solution</h1>
      </div>

      <div className="flex flex-col justify-center items-center gap-8 max-w-[50rem] mx-auto text-center p-[3rem]">
        <p>
          Established in 2006, our Mail Management Solutions business was
          created to cater to corporations and industries alike! As is the case
          with most of our products, due to our longstanding expertise,
          reliability and vast network, this business allows us to provide
          organizations and large corporations with a one stop solution for
          their printing, mail processing, delivery, and distribution needs
        </p>
        <p>
          Our MMS faction is divided into two main businesses, namely print and
          bulk distribution. We have Pakistan’s fastest digital transaction
          facility where along with printing we also offer automated stuffing
          and insertion facilities based out of and Lahore. Some of our other
          MMS services include:
        </p>
      </div>
      <div className="bg-[#f6f6f6] flex flex-col justify-center items-center p-[3rem]">
        <h1 className="text-[24px] font-bold">
          The complete service portfolio includes:
        </h1>
        <div className="flex justify-center items-center gap-[2rem] mt-8">
          <img src="/portfolio.png" alt="" className="object-contain h-[16rem]" />
          <ul className="list-disc">
            <li>Digital Printing</li>
            <li>Automatic Stuffing &amp; Insertion</li>
            <li>Mail Room Management</li>
            <li>Bulk Volume Delivery</li>
            <li>Customized Solutions</li>
            <li>Nationwide Delivery</li>
            <li>Special Project Delivery</li>
            <li>Leaflet Delivery</li>
            <li>BTL Marketing activities</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default MailManagement;
